import * as types from './mutation-types'

export default {
  [types.SET_INVOICES] (state, invoices) {
    state.invoices = invoices
  },

  [types.SET_TOTAL_INVOICES] (state, totalInvoices) {
    state.totalInvoices = totalInvoices
  },

  [types.ADD_INVOICE] (state, data) {
    state.invoices.push(data)
  },
  [types.INVOICE_HAS_DELIVERYNOTE](state, data) {
    state.invoiceHasDeliveryNote=true
  },
  [types.SET_DELIVERYNOTE_ITEM](state, data) {
    state.deliverynoteItems = data
  },
  
  

  [types.DELETE_INVOICE] (state, id) {
    let index = state.invoices.findIndex(invoice => invoice.id === id)
    state.invoices.splice(index, 1)
  },

  [types.SET_SELECTED_INVOICES] (state, data) {
    state.selectedInvoices = data
  },

  [types.UPDATE_INVOICE] (state, data) {
    let pos = state.invoices.findIndex(invoice => invoice.id === data.invoice.id)

    state.invoices[pos] = data.invoice
  },

  [types.UPDATE_INVOICE_STATUS] (state, data) {
    let pos = state.invoices.findIndex(invoice => invoice.id === data.id)

    if (state.invoices[pos]) {
      state.invoices[pos].status = data.status
    }
  },

  [types.RESET_SELECTED_INVOICES] (state, data) {
    state.selectedInvoices = []
    state.selectAllField = false
  },

  [types.DELETE_MULTIPLE_INVOICES] (state, selectedInvoices) {
    selectedInvoices.forEach((invoice) => {
      let index = state.invoices.findIndex(_inv => _inv.id === invoice.id)
      state.invoices.splice(index, 1)
    })
    state.selectedInvoices = []
  },

  [types.SET_TEMPLATE_ID] (state, templateId) {
    state.invoiceTemplateId = templateId
  },

  [types.SELECT_CUSTOMER] (state, data) {
    state.selectedCustomer = data
  },

  [types.RESET_SELECTED_CUSTOMER] (state, data) {
    state.selectedCustomer = null
  },

  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  },

  [types.SET_SELECT_ALL_STATE_ITEM](state, data) {
    state.selectAllFieldItem = data
  },
  [types.SET_SELECTED_INVOICE_ITEMS](state, data) {
    state.selectedInvoiceItems = data
  },
  [types.RESET_SELECTED_INVOICE_ITEMS](state, data) {
    state.selectedInvoiceItems = []
    state.selectAllFieldItem = false
  },

  [types.SET_SELECT_ALL_STATE_ITEM](state, data) {
    state.selectAllFieldItem = data
  },
  [types.SET_INVOICE_ITEMS](state, data) {
    state.invoiceItems = data
  },
  

  [types.DELETE_INVOICE_MULTIPLE_ITEMS](state, selectedInvoiceItems) {
    selectedInvoiceItems.forEach((item) => {
      let index = state.invoiceItems.findIndex(_item => _item.systemItemId === item)
      if (state.deliverynoteItems) {
        let addItem = state.invoiceItems.find(obj => obj.systemItemId === item)
        state.deliverynoteItems.push(addItem)
        console.log('state.deliverynoteItems')
        console.log(state.deliverynoteItems)
      }
      state.invoiceItems.splice(index, 1)
    })
    state.selectedInvoiceItems = []
  },

  [types.TEMP_MULTIPLE_DELETE_ITEMS](state, items) {
    items.forEach((item) => {
      let index = state.availableInvoiceItems.findIndex(_item => _item.id === item.id)
      state.availableInvoiceItems.splice(index, 1)
    })
  },
  [types.TEMP_DELETE_ITEM](state, data) {
    console.log(data)
    console.log(state.availableInvoiceItems)
    if (data.id) {
      let index = state.availableInvoiceItems.findIndex(obj => obj.id === data.id)
      if (index != undefined && index > -1) {
        console.log('start index')
        console.log(index)
        console.log('end index')
        state.availableInvoiceItems.splice(index, 1)
        console.log(state.availableInvoiceItems)
      }
    }
    if (data.systemItemId) {
      let index = state.availableInvoiceItems.findIndex(obj => obj.systemItemId === data.systemItemId)
      if (index != undefined && index > -1) {
        console.log('start index')
        console.log(index)
        console.log('end index')
        state.availableInvoiceItems.splice(index, 1)
        console.log(state.availableInvoiceItems)
      }
    }

    if (data.item_id) {
      let index1 = state.availableInvoiceItems.findIndex(obj => obj.id === data.item_id)
      if (index1 != undefined && index1 > -1) {
        console.log('item start')
        console.log(index1)
        console.log('item end')
        state.availableInvoiceItems.splice(index1, 1)
      }
    }

  },
  [types.TEMP_ADD_ITEM](state, data) {
    if (data.original_item_id && data.name) {
      data.index = null
      data.id = data.original_item_id
      delete data.item_id
      data.item_id = null
      console.log('add data')
      console.log(data)
      state.availableInvoiceItems.push(data)
      console.log(state.availableInvoiceItems)
    }
  },
  [types.ADD_INVOICE_ITEMS](state, data) {
    state.invoiceItems.push(data)
    console.log('add data')
    console.log(data)
    console.log('invoiceItems data')
    console.log(state.invoiceItems)
  },
  

  [types.DELETE_INVOICE_ITEM](state, item) {
    console.log('DELETE_DELIVERY_NOTE_ITEM')
    console.log(item)
    console.log(state.invoiceItems)
    console.log(state.deliverynoteItems)

      if (state.deliverynoteItems.length > 0 && item.systemItemId != null) {
        console.log('state.POItems.length>0 && item.systemItemId != null')

        let removeItemIndex = state.invoiceItems.findIndex(invoiceItem => invoiceItem.systemItemId === item.systemItemId)
        console.log("removeItemIndex" + removeItemIndex)
        if (removeItemIndex >= 0) {
          if (item.systemItemId) {
            let addItem = state.invoiceItems.find(obj => obj.systemItemId === item.systemItemId)
            state.POItems.push(addItem)
          }
          state.invoiceItems.splice(removeItemIndex, 1)
          console.log('delete invoiceItems data')
          console.log(state.invoiceItems)
        } else {

        }



      }
      else if (state.deliverynoteItems.length > 0 && item.systemItemId == null) {
        console.log('state.POItems.length>0 && item.systemItemId == null')
        let removeItemIndex = state.invoiceItems.findIndex(invoiceItem => invoiceItem.id === item.id)
        state.invoiceItems.splice(removeItemIndex, 1)
        console.log('delete invoiceItems data')
        console.log(state.invoiceItems)
      }
      else if (state.deliverynoteItems.length == 0 && item.systemItemId == null) {
        console.log('state.POItems.length=0 && item.systemItemId == null')
        let removeItemIndex = state.invoiceItems.findIndex(invoiceItem => invoiceItem.id === item.id)
        state.invoiceItems.splice(removeItemIndex, 1)
        console.log("removeItemIndex" + removeItemIndex)
        console.log("after remove delivery Notes")
        console.log(state.invoiceItems)
      }
      else if (state.deliverynoteItems.length == 0 && item.systemItemId != null) {
        console.log('state.POItems.length == 0 && item.systemItemId != null')
        let removeItemIndex = state.invoiceItems.findIndex(invoiceItem => invoiceItem.systemItemId === item.systemItemId)
        console.log("removeItemIndex" + removeItemIndex)
        if (removeItemIndex >= 0) {
          if (item.systemItemId) {
            let addItem = state.invoiceItems.find(obj => obj.systemItemId === item.systemItemId)
            state.deliverynoteItems.push(addItem)
          }
          state.invoiceItems.splice(removeItemIndex, 1)
          console.log('delete deliveryNoteItems data')
          console.log(state.invoiceItems)
        } else {

        }

      }
  },

}
